import logo from "../assests/logo-game.jpeg";
import { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Avatar from "react-avatar";
import ShopDropdown from "./ShopDropdown";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const SERVER_BASE_URL = BASE_URL.replace(/\/api$/, "");

  const { cart, updateCartItem, removeFromCart, getTotalItems } = useCart();
  const { logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const [mobileShopOpen, setMobileShopOpen] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/");
    window.location.reload();
  };

  const getTotalPrice = () => {
    return cart.reduce((total, item) => {
      return total + Number(item.price) * (item.pieces || 1);
    }, 0);
  };

  return (
    <>
      {" "}
      {/* Navbar */}
      <header
        className={`fixed w-full z-50 transition-all duration-500 ${
          scrolled
            ? "bg-black/90 backdrop-blur-md py-2 shadow-xl"
            : "bg-transparent py-4"
        }`}
      >
        <div className="container mx-auto px-6">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <Link to={"/"}>
              <div className="flex items-center group">
                <img src={logo} alt="" className="w-20 rounded-full" />
                <span className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-600 group-hover:bg-gradient-to-l transition-all duration-500 tracking-tighter">
                  GAME ZTUDIO
                </span>
                {/* <span className="ml-2 text-xs bg-purple-600 text-white px-2 py-1 rounded-full animate-pulse">
                                SHOP
                            </span> */}
              </div>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex space-x-8 items-center">
              <a
                href="/"
                className="relative text-sm font-medium text-white/80 hover:text-white transition-colors group"
              >
                Home
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300"></span>
              </a>

             <ShopDropdown closeMenu={() => setMenuOpen(false)} variant="desktop" />
              <a
                href="/about-us"
                className="relative text-sm font-medium text-white/80 hover:text-white transition-colors group"
              >
                About
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300"></span>
              </a>
              <a
                href="/contact-us"
                className="relative text-sm font-medium text-white/80 hover:text-white transition-colors group"
              >
                Contact
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300"></span>
              </a>

              <div className="w-px h-6 bg-white/20 mx-4"></div>

              <button
                onClick={() => setCartOpen(true)}
                className="relative p-2 text-white hover:text-cyan-400 transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 6M7 13l-1.5 6m9.5-6h.01M19 21a2 2 0 100-4 2 2 0 000 4z"
                  />
                </svg>
                {getTotalItems() > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {getTotalItems()}
                  </span>
                )}
              </button>

              {/* Auth Section */}
              {!storedUser ? (
                <button className="relative px-4 py-2 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-full group overflow-hidden hover:scale-105 transition-transform">
                  <Link to="/login">
                    <span className="relative z-10 text-sm font-medium text-white">
                      LOGIN
                    </span>
                  </Link>
                </button>
              ) : (
                <div className="relative">
                  <button
                    onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
                    className="flex items-center space-x-2 focus:outline-none"
                  >
                    <div className="w-10 h-10 rounded-full border-2 border-cyan-400 shadow-md overflow-hidden">
                      <Avatar
                        name={storedUser.name}
                        size="40"
                        round={true}
                        color="#06b6d4"
                        fgColor="#ffffff"
                        src={
                          storedUser.avatar
                            ? `${SERVER_BASE_URL}${storedUser.avatar}`
                            : null
                        }
                      />
                    </div>
                  </button>

                  {profileDropdownOpen && (
                    <div className="absolute right-0 mt-3 w-48 bg-gray-900 border border-cyan-500 rounded-xl shadow-lg py-2 z-50">
                      <Link
                        to="/user-profile"
                        className="block px-4 py-2 text-sm text-white font-semibold hover:bg-cyan-500 hover:text-white rounded-t-lg"
                        onClick={() => setProfileDropdownOpen(false)}
                      >
                        My Profile
                      </Link>
                      <Link
                        to="/my-orders"
                        className="block px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-500 hover:text-white"
                        onClick={() => setProfileDropdownOpen(false)}
                      >
                        My Orders
                      </Link>
                      {/* <Link
                        to="/order-tracking"
                        className="block px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-500 hover:text-white"
                        onClick={() => setProfileDropdownOpen(false)}
                      >
                        Track Order
                      </Link> */}
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2 text-sm text-red-400 font-semibold hover:bg-red-500 hover:text-white rounded-b-lg"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}
            </nav>

            {/* Mobile Toggle */}
            <button
              className="lg:hidden text-white focus:outline-none"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"
                  }
                />
              </svg>
            </button>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <div className=" bg-black backdrop-blur-sm">
              <div className="px-6 pt-10 pb-6 space-y-4 overflow-y-auto h-full">
                <div className="lg:hidden mt-4 px-6 pb-6 space-y-4">
                  <Link
                    to="/"
                    className="block py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors"
                    onClick={() => setMenuOpen(false)}
                  >
                    Home
                  </Link>
                 <ShopDropdown closeMenu={() => setMenuOpen(false)} variant="mobile" />
                  <Link
                    to="/about-us"
                    className="block py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors"
                    onClick={() => setMenuOpen(false)}
                  >
                    About
                  </Link>
                  <Link
                    to="/contact-us"
                    className="block py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors"
                    onClick={() => setMenuOpen(false)}
                  >
                    Contact
                  </Link>
                  <button
                    onClick={() => {
                      setCartOpen(true);
                      setMenuOpen(false);
                    }}
                    className="block py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors"
                  >
                    View Cart
                  </button>
                  {!storedUser ? (
                    <Link
                      to="/login"
                      className="block py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors"
                      onClick={() => setMenuOpen(false)}
                    >
                      Login
                    </Link>
                  ) : (
                    <>
                      <Link
                        to="/user-profile"
                        className="block py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors"
                        onClick={() => setMenuOpen(false)}
                      >
                        My Profile
                      </Link>
                      <Link
                        to="/my-orders"
                        className="block py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors"
                        onClick={() => setMenuOpen(false)}
                      >
                        My Orders
                      </Link>
                      <button
                        onClick={() => {
                          handleLogout();
                          setMenuOpen(false);
                        }}
                        className="block py-2 text-lg font-medium text-red-400 hover:text-white transition-colors"
                      >
                        Logout
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </header>
      {/* Cart Offcanvas */}
      {cartOpen && (
        <div className="fixed inset-0 z-50 overflow-hidden">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setCartOpen(false)}
          ></div>

          {/* Cart Sidebar */}
          <div className="absolute right-0 top-0 h-full w-full max-w-md bg-gray-900 shadow-xl">
            <div className="flex flex-col h-full">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-800">
                <h2 className="text-xl font-bold text-white">Shopping Cart</h2>
                <button
                  onClick={() => setCartOpen(false)}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Cart Items */}
              <div
                className="flex-1 overflow-y-auto p-6 "
                style={{
                  scrollbarWidth: "thin", // Firefox
                  scrollbarColor: "#64748b transparent", // Firefox (slate-500)
                }}
              >
                {cart.length === 0 ? (
                  <div className="text-center text-gray-400 mt-8">
                    <div className="text-4xl mb-4">🛒</div>
                    <p>Your cart is empty</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {cart.map((item) => {
                      const product = item.product_id ? item.product_id : item;
                      const isGuest = !item.product_id;
                      const itemId = isGuest ? item._id : item._id;
                      // handleDecrease
                      const handleDecrease = () => {
                        if ((item.pieces || 1) <= 1) {
                          removeFromCart(itemId);
                        } else {
                          updateCartItem(itemId, (item.pieces || 1) - 1);
                        }
                      };

                      // handleIncrease
                      const handleIncrease = () => {
                        updateCartItem(itemId, (item.pieces || 1) + 1);
                      };

                      // handleRemove
                      const handleRemove = () => {
                        removeFromCart(itemId);
                      };
                      return (
                        <div
                          key={item._id || item.product_id} // Fallback key
                          className="flex items-center space-x-4 bg-gray-800/50 rounded-lg p-4 relative"
                        >
                          <div className="w-12 h-12 overflow-hidden rounded-lg">
                            <img
                              src={`${process.env.REACT_APP_API_IMAGE_URL}${product?.image[0]}`}
                              alt={product?.name || "Product"}
                              className="w-full h-full object-cover"
                            />
                          </div>

                          <div className="flex-1">
                            <h3 className="font-medium text-white line-clamp-1">
                              {product?.name || "Product"}
                            </h3>
                            <p className="text-cyan-400 font-bold">
                              ₹{Number(item.price).toLocaleString()}
                            </p>
                          </div>

                          <div className="flex items-center space-x-2">
                            <button
                              onClick={handleDecrease}
                              className="w-8 h-8 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white"
                            >
                              -
                            </button>
                            <span className="text-white font-medium w-8 text-center">
                              {item.pieces || 1}
                            </span>
                            <button
                              onClick={handleIncrease}
                              className="w-8 h-8 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white"
                            >
                              +
                            </button>

                            <button
                              onClick={handleRemove}
                              className="ml-2 text-gray-500 hover:text-red-500 transition-colors"
                              title="Remove"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5-4h4a1 1 0 011 1v1H9V4a1 1 0 011-1z"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Footer */}
              {cart.length > 0 && (
                <div className="border-t border-gray-800 p-6 space-y-6">
                  {/* Total */}
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-semibold text-white">
                      Total
                    </span>
                    <span className="text-2xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-500">
                      ₹{getTotalPrice().toLocaleString()}
                    </span>
                  </div>

                  {/* Buttons */}
                  <div className="space-y-3 mt-4">
                    <Link to="/checkout" className="block">
                      <button
                        onClick={() => setCartOpen(false)}
                        className="w-full py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-full text-white font-bold hover:shadow-lg hover:shadow-cyan-500/30 transition-all"
                      >
                        PROCEED TO CHECKOUT
                      </button>
                    </Link>

                    <button
                      onClick={() => setCartOpen(false)}
                      className="w-full py-3 border-2 border-gray-600 rounded-full text-white font-medium hover:bg-gray-800 transition-all"
                    >
                      CONTINUE SHOPPING
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
